import { render, staticRenderFns } from "./HistoryRecord.vue?vue&type=template&id=786597b2&scoped=true&"
import script from "./HistoryRecord.vue?vue&type=script&lang=ts&"
export * from "./HistoryRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786597b2",
  null
  
)

export default component.exports